import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { ModalOverlay } from "../Modal/Modal";

import useMapData from "../../utils/useMapData";

import { BannerStatus } from "../../StyledCmp";

import "./Banner.scss";

const Banner = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const handleModalVisibility = () => {
    setIsModalVisible(prevState => !prevState);
  };

  return (
    <div className="banner_wrapper">
      <BannerStatus>Booking Open</BannerStatus>
      <h3 style={{ color: resultList?.themeColor }} className="banner_title">
        {resultList?.projectName}
      </h3>
      <p id="banner_subTitle">At {resultList?.locationName}</p>
      <span>By {resultList?.projectOwner}</span>
      <div
        style={{ background: resultList?.themeColor }}
        className="banner_sub_section"
      >
        <div className="overlay" onClick={handleModalVisibility}>
          <p id="banner_desc">
            {resultList?.bannerOverlayInfo?.map((item, index) => {
              return <span key={index}>{item}</span>;
            })}
          </p>
        </div>
      </div>
      <div className="banner_footer">
        <h3>{resultList?.bannerOverlayText?.title}</h3>
        <p>{resultList?.bannerOverlayText?.subTitle}</p>
        <button
          style={{ background: resultList?.themeColor }}
          id="bannerBtn"
          onClick={handleModalVisibility}
        >
          Enquire Now
        </button>
      </div>
      {isModalVisible && (
        <ModalOverlay
          isModalVisible={isModalVisible}
          handleModalVisibility={handleModalVisibility}
          title={"Mail Me Costing Details"}
          btnText="Send Now"
          actionType="mail-costing-details"
        />
      )}
    </div>
  );
};

export default Banner;
